import React from 'react';
import { FastField as FormikField } from 'formik';
import { Textarea } from '@xo-union/tk-component-fields';
import styles from './styles.scss';

interface AnswerTextboxP {
  name: string;
  placeholder: string;
}

interface TextAreaProps {
  name: string;
  placeholder: string;
  disabled?: boolean;
  label?: string;
}

const TextArea: React.FC<TextAreaProps> = ({ name, placeholder, label, disabled = false }) => (
  <FormikField name={name}>
    {({ field, form }: any): React.ReactElement => (
      <Textarea
        {...field}
        data-testid="AnswerTextbox"
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
          form.handleChange({ ...e, value: e.target.value.trim() })
        }
        label={label || false}
        placeholder={placeholder}
        rows={4}
        value={field.value || ''}
        disabled={disabled}
      />
    )}
  </FormikField>
);

const AnswerTextbox: React.FC<AnswerTextboxP> = ({ name, placeholder }) => {
  return (
    <div className={styles.answerTextbox}>
      <TextArea name={name} label={placeholder} placeholder={placeholder} />
    </div>
  );
};

export default AnswerTextbox;
